import type { TranslationKey } from "@privacy/translations";
import { useTranslation } from "@privacy/translations";
import { Stack, Typography } from "@mui/material";
import type { FC, ReactNode } from "react";

type EmptyStateProps =
  | { labelKey: TranslationKey; label?: never; action?: ReactNode }
  | { labelKey?: never; label: string; action?: ReactNode };

export const EmptyState: FC<EmptyStateProps> = ({ labelKey, label, action }) => {
  const { t } = useTranslation();
  return (
    <Stack
      sx={{
        height: "inherit",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        transform: "translateY(-100px)",
      }}
    >
      <Typography
        sx={{
          textAlign: "center",
          maxWidth: "23rem",
          fontSize: theme => theme.typography.pxToRem(14),
          textWrap: "balance",
          color: theme => theme.palette.text.tertiary,
        }}
      >
        {labelKey ? t(labelKey) : label}
      </Typography>
      {action}
    </Stack>
  );
};
